
import { Button, Descriptions } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";

export default function () {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({});

    useEffect(() => {
        axiosInstance.get(`employee/${id}/clothingSizes`).then(({ data }) => setData(data));
    },[]);

    return (
        <Descriptions
            column={1}
            extra={
                <>
                    <Button type="link" onClick={() => navigate("clothingSizes/edit")}>
                        Modifica
                    </Button>
                </>
            }
        >
            <Descriptions.Item label="Top (maglietta - giacca - felpa)">{data.topSize}</Descriptions.Item>
            <Descriptions.Item label="Pantaloni">{data.bottomSize}</Descriptions.Item>
            <Descriptions.Item label="Scarpe">{data.shoesSize}</Descriptions.Item>
            <Descriptions.Item label="Guanti">{data.glovesSize}</Descriptions.Item>
        </Descriptions>
    );
}
